// src/services/menuService.ts
import { apiService } from './api';

export interface SideMenuItem {
  SideMenuId: number;
  Name: string;
  Text: string;
  Css: string;
  Url: string;
  Icon: string;
  Counter: number;
  Selected: boolean;
  HasChanged: boolean;
  ConfigValueID: number;
  OrderSideMenu: number;
  ShowSeparator: boolean;
}

class MenuService
{
  async getMenuByPerson(): Promise<SideMenuItem[]>
  {
    try
    {
      const response = await apiService.get<SideMenuItem[]>('menu/getbyperson');
      if (response && response.length > 0)
      {
        sessionStorage.setItem('C2_sideMenuItems', JSON.stringify(response));
      }
      return response || [];
    }
    catch (error)
    {
      console.error('Error fetching menu:', error);
      return [];
    }
  }
}

export const menuService = new MenuService();
